import SearchResultsPage from "src/pages/SearchResults";
import { createGetServerSideProps } from "src/utilities/ssr/createGetServerSideProps";
import { getSearchPageServerSideProps } from "src/utilities/ssr/getSearchPageServerSideProps";
import { withPropsDeserialization } from "src/utilities/ssr/withPropsDeserialization";

export const getServerSideProps = createGetServerSideProps(
  getSearchPageServerSideProps
);

export default withPropsDeserialization(SearchResultsPage);
